
export default {
    props: {
        title: {
            type: String
        },
        content: {
            type: String
        },
        province_name:{
            type:String
        },
        district_name:{
            type:String
        },
        ward_name:{
            type:String
        },
        logo: {
            type: String
        },
        isLink: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        getLink(){
            if(this.isLink){
                if(this.content.includes('@')){
                    return `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=${this.content}`
                }
              return  this.content.includes('http') ? this.content : `https://${this.content}`
            }
        },
        // addressSuffix() {
        //     const parts = [];
        //     if (this.ward_name) parts.push(this.ward_name);
        //     if (this.district_name) parts.push(this.district_name);
        //     if (this.province_name) parts.push(this.province_name);
        //     return parts.length ? ', ' + parts.join(', ') : '';
        //     //  return parts.length ? `, ${parts.join(', ')}` : '';
        // },
         fullAddress() {
            return [
                this.content?.trim(),
                this.ward_name,
                this.district_name,
                this.province_name
            ]
                .filter(item => item && item.trim())
                .join(', ');
        }
    },
    mounted() {

    }
}
